export const login = (payload) => { 
 console.log("USER_LOGGED_IN: " + JSON.stringify(payload));
  return {
    type: "USER_LOGGED_IN",
    payload
  }
}
